import React from 'react';

//import DeleteIcon from '@mui/icons-material/Delete';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import DropdownCardMenu from 'common/components/DropdownCardMenu';

//import * as actions from '../actions';
import { SOURCE_FIELD_KEYS } from '../constants';
import * as selectors from '../selectors';

import InfoCell from './InfoCell';
import Table from './Table';

const ManualSourceList = ({
    disabled,
    externalSources,
    isFetchingExternalSources,
}) => {
    const { t } = useTranslation();
    const infoKeys = Object.values(SOURCE_FIELD_KEYS);

    const columns = [
        {
            align: 'left',
            field: 'brand',
            flex: 1,
            headerName: t('Brand'),
            minWidth: 200,
            sortable: false,
            valueGetter: (_, row) => row?.brand || '--',
        },
        {
            align: 'left',
            field: 'name',
            flex: 1,
            headerName: t('Name'),
            minWidth: 200,
            sortable: false,
            valueGetter: (_, row) => row?.name || '--',
        },
        {
            align: 'left',
            field: 'type',
            flex: 1,
            headerName: t('Type'),
            minWidth: 200,
            sortable: false,
            valueGetter: (_, row) => row?.type || '--',
        },
        {
            align: 'left',
            field: 'information',
            flex: 2,
            headerName: t('Information'),
            minWidth: 200,
            renderCell: (_, { row }) => (
                <InfoCell infoKeys={infoKeys} row={row} />
            ),
            sortable: false,
        },
        {
            align: 'right',
            field: 'actions',
            headerName: '',
            renderCell: ({ row }) => (
                <DropdownCardMenu
                    items={[
                        {
                            disabled,
                            label: t('View'),
                            icon: <OpenInNewIcon />,
                            link: row?.url,
                            linkOptions: {
                                component: 'a',
                                rel: 'noopener noreferrer',
                                target: '_blank',
                            },
                            visible: Boolean(row?.url),
                        },
                    ]}
                />
            ),
            sortable: false,
            width: 50,
        },
    ];

    return (
        <Table
            columns={columns}
            isLoading={isFetchingExternalSources}
            items={externalSources}
            selectable={false}
        />
    );
};

ManualSourceList.propTypes = {
    disabled: PropTypes.bool,
    externalSources: PropTypes.array,
    isFetchingExternalSources: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
    isFetchingExternalSources: selectors.getIsFetchingExternalSources,
});

export default connect(mapStateToProps)(ManualSourceList);
